module.exports = __webpack_public_path__ + "img/souhushandian.54a205b3.png";